import { api } from '@/api'

type ImageUploadResponce = {
  imageId: number
  imageUrl: string
  success: boolean
}

const uploadImgService = api.injectEndpoints({
  endpoints: (build) => ({
    UploadFeaturesImage: build.mutation<ImageUploadResponce, FormData>({
      query: (body) => ({
        url: '/devices/addLightingImage',
        method: 'POST',
        body,
      }),
    }),
    DeleteFeaturesImage: build.mutation<
      ImageUploadResponce,
      { deviceId: number }
    >({
      query: (body) => ({
        url: '/devices/deleteLightingImage',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useUploadFeaturesImageMutation,
  useDeleteFeaturesImageMutation,
} = uploadImgService
